import styled from 'styled-components';
import * as RadixPopover from '@radix-ui/react-popover';

export const StyledContent = styled(RadixPopover.Content)`
    display: flex;
    flex-direction: column;
    max-height: var(--radix-popper-available-height);
    z-index: 9999;
`;
